import { Reducer } from 'redux';
import ActionTypes from './types';
import { MapStyleControllerState } from './types';

export const initialState: MapStyleControllerState = {
  basemapOptions: [],
  basemapError: ''
};

const reducer: Reducer<MapStyleControllerState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case ActionTypes.GET_BASE_MAPS_SUCCESS:
      return {
        ...state,
        basemapOptions: action.payload,
        basemapError: ''
      };
    case ActionTypes.GET_BASE_MAPS_FAILURE:
      return {
        ...state,
        basemapOptions: [],
        basemapError: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
